import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import trueSquare from '../../assets/motor/truesquare.png'

import _ from 'lodash'
import numeral from 'numeral'
import { motorService } from '../../services/motor.service'
import Modal from '@material-ui/core/Modal'
import Loading from '../../components/Loading'
import Icon from '@material-ui/core/Icon'
import moment from 'moment'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  contentHeader: {
    borderTop: '1px solid #dee1e9',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  contentHeaderOpen: {
    borderTop: '1px solid #dee1e9',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  contentHeaderTitle: {
    ...fontDefault,
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  contentHeaderSemiTitle: {
    ...fontDefault,
    color: '#4a4a4a',
    fontSize: '14px',
  },
  contentHeaderSubTitle: {
    ...fontDefault,
    color: '#4a4a4a',
    fontSize: '14px',
  },
  contentHeaderSubPrice: {
    ...fontDefault,
    color: '#4a4a4a',
    fontSize: '14px',
    fontFamily: 'San Francisco Text',
  },
  contentHeaderPrice: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  container: {
    margin: '16px',
  },
  contentDesc: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '14px',
    marginTop: '16px',
    display: 'block',
  },

  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    ...fontDefault,
    color: '#878B96',
    fontSize: '14px',
  },
  textBold: {
    ...fontDefault,
    color: '#878B96',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  line: {
    border: '0.5px solid #878B96',
  },
  blueLine: {
    border: '0.5px solid #328DF5',
  },
  paymentContainer: {
    marginTop: '16px',
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #118df5',
    padding: '16px',
    cursor: 'pointer',
  },
  paymentContainerActive: {
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #328DF5',
    padding: '15px',
  },
  paymentHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  paymentImage: {
    width: '50px',
    height: '50px',
    borderRadius: '50px',
    border: '1px solid #ededed',
    padding: '5px',
  },
  paymentTitleContainer: {
    marginLeft: '15px',
  },
  paymentTitle: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '16px',
    margin: '0px',
  },
  paymentTitleDetail: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '14px',
    margin: '0px',
  },
  paymentContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '6px',
  },
  paymentPrice: {
    ...fontDefault,
    fontSize: '24px',
    color: '#0B0A0A',
  },
  paymentPriceActive: {
    ...fontDefault,
    fontSize: '24px',
    color: '#328DF5',
  },
  paymentPriceText: {
    ...fontDefault,
    fontSize: '14px',
    color: '#979797',
  },
}

const dateStringToText = (inputdate = '0001-01-01') => {
  const date = new Date(inputdate + 'T07:00:00')
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear() + 543).slice(-2)
  return day + '/' + month + '/' + year
}

class PaymentPlan extends Component {
  state = {
    isLoading: false,
    isExpand: false,
  }

  goToNextPage = async () => {
    const {
      history: { push },
      setUserInput,
      auth,
    } = this.props
    const token = _.get(auth, 'token', null)
    try {
      this.setState({
        isLoading: true,
      })
      const response = await motorService.getOTP(token)
      if (response.success) {
        setUserInput({
          OTPRef: _.get(response, 'otp_ref', ''),
        })
        this.setState({
          isLoading: false,
        })
        push('/verify-otp')
      } else {
        if (response.code === 500) {
          push('/error-system')
          document.getElementById("rootScreen").scrollTo(0, 0)
          return
        }
      }
    } catch (error) {
      const { showError } = this.props
      showError(error.message)
      this.setState({
        isLoading: true,
      })
      if (error.message === 'Network Error') {
        push('/error-network')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
      const response = _.get(error, 'response', {})
      const responseStatus = response.status
      if (
        responseStatus === 500 ||
        responseStatus === 403 ||
        responseStatus === 401 ||
        responseStatus === 400
      ) {
        push('/error-system')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
    }
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/summary')
  }

  render() {
    const {
      classes,
      userInput,
      balance,
      selectPrice,
      currentProduct,
    } = this.props
    const currentPackage = _.get(userInput, 'currentPackage', {})
    const { isVMIIncludeCMI } = userInput
    const { isLoading, isExpand } = this.state
    const effDate = _.get(userInput, 'effDate', '0001-01-01') || '0001-01-01'
    const startEffDate = moment(effDate).format('YYYY-MM-DD')
    const endEffDate = moment(effDate)
      .add(1, 'years')
      .format('YYYY-MM-DD')

    const dateFromTo =
      dateStringToText(startEffDate) + ' - ' + dateStringToText(endEffDate)
    return (
      <Wrapper>
        <Body>
          {isExpand ? (
            <div className={classes.contentHeaderOpen}>
              <div
                onClick={() => {
                  this.setState({
                    isExpand: false,
                  })
                }}
                style={{
                  padding: '16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span className={classes.contentHeaderTitle}>รายละเอียด</span>
                <Icon className={classes.expandIcon}>expand_less</Icon>
              </div>
              <div
                style={{
                  padding: '16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span className={classes.contentHeaderSemiTitle}>
                  ยอดเรียกทำรายการ
                </span>
                <span className={classes.contentHeaderPrice}>
                  ฿ {numeral(parseFloat(selectPrice)).format('0,0.00')}
                </span>
              </div>
              <hr
                style={{
                  borderTop: '1px solid #dee1e9',
                  borderBottom: 'none',
                  marginLeft: '16px',
                  marginRight: '16px',
                }}
              />
              <div
                style={{
                  padding: '16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span className={classes.contentHeaderSubTitle}>
                  {currentProduct === 'V'
                    ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
                      ? !isVMIIncludeCMI
                        ? 'ประกันชั้น 2+'
                        : 'ประกันชั้น 2+ และ พ.ร.บ.'
                      : parseInt(_.get(currentPackage, 'risk', 0)) === 1
                      ? !isVMIIncludeCMI
                        ? 'ประกันชั้น 1'
                        : 'ประกันชั้น 1 และ พ.ร.บ.'
                      : !isVMIIncludeCMI
                      ? 'ประกันชั้น 3'
                      : 'ประกันชั้น 3 และ พ.ร.บ.'
                    : 'พ.ร.บ.'}{' '}
                  {_.get(currentPackage, 'garage', '') === 'DG'
                    ? 'ซ่อมศูนย์'
                    : _.get(currentPackage, 'garage', '')}
                </span>
                <span className={classes.contentHeaderSubPrice}>
                  ฿ {numeral(parseFloat(selectPrice)).format('0,0.00')}
                </span>
              </div>
              <div
                style={{
                  padding: '0px 16px 16px 16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span className={classes.contentHeaderSubTitle}>
                  วันที่คุ้มครอง
                </span>
                <span className={classes.contentHeaderSubPrice}>
                  {dateFromTo}
                </span>
              </div>
              <div
                style={{
                  padding: '0px 16px 16px 16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span className={classes.contentHeaderSubTitle}>
                  รับเงินคืนทางวอลเล็ท
                </span>
                <span className={classes.contentHeaderSubPrice}>
                  ฿{' '}
                  {numeral(
                    parseFloat(_.get(currentPackage, 'cashback_value', 0)) +
                      (isVMIIncludeCMI
                        ? parseFloat(
                            _.get(currentPackage, 'cashback_value_cmi', 0)
                          )
                        : 0)
                  ).format('0,0.00')}
                </span>
              </div>
              <hr
                style={{
                  borderTop: '1px solid #dee1e9',
                  borderBottom: 'none',
                  marginLeft: '16px',
                  marginRight: '16px',
                }}
              />
              <div
                style={{
                  padding: '16px',
                }}
              >
                <span className={classes.contentHeaderSubTitle}>หมายเหตุ</span>
                <p
                  style={{
                    ...fontDefault,
                    color: '#999999',
                    fontSize: '12px',
                    margin: '0px',
                  }}
                >
                  กรุงเทพประกันภัยจะส่งกรมธรรม์ให้คุณทางอีเมล{' '}
                  {_.get(userInput, 'email', '')}
                  หากไม่ได้รับอีเมลภายใน 20 นาที
                  กรุณาติดต่อบริษัทกรุงเทพประกันภัย 0 2285 8888
                </p>
              </div>
              <hr
                style={{
                  borderTop: '1px solid #dee1e9',
                  borderBottom: 'none',
                  marginLeft: '16px',
                  marginRight: '16px',
                }}
              />
              <div
                style={{
                  padding: '16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span className={classes.contentHeaderTitle}>ยอดชำระ</span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className={classes.contentHeaderPrice}>
                    ฿ {numeral(parseFloat(selectPrice)).format('0,0.00')}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div
              className={classes.contentHeader}
              onClick={() => {
                this.setState({
                  isExpand: true,
                })
              }}
            >
              <span className={classes.contentHeaderTitle}>ยอดชำระ</span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span className={classes.contentHeaderPrice}>
                  ฿ {numeral(parseFloat(selectPrice)).format('0,0.00')}
                </span>

                <Icon
                  className={classes.expandIcon}
                  style={{ marginLeft: '8px' }}
                >
                  expand_more
                </Icon>
              </div>
            </div>
          )}
          <div className={classes.container}>
            <span className={classes.contentHeaderTitle}>ช่องทางชำระเงิน</span>
            <div
              className={classes.paymentContainer}
              onClick={() => {
                this.setState({
                  isActive: true,
                })
              }}
            >
              <div className={classes.paymentHeader}>
                <div
                  style={{
                    padding: '3px',
                    borderRadius: '50%',
                    border: '1px solid #118df5',
                    marginRight: '16px',
                  }}
                >
                  <div
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '4px',
                      backgroundColor: '#118df5',
                    }}
                  />
                </div>
                <img
                  alt="True Money Wallet"
                  src={trueSquare}
                  className={classes.paymentImage}
                />
                <div className={classes.paymentTitleContainer}>
                  <p className={classes.paymentTitle}>ทรูมันนี่ วอลเล็ท</p>
                  <p className={classes.paymentTitleDetail}>
                    ยอดเงินคงเหลือ{' '}
                    {numeral(parseFloat(balance || 0) / 100).format('0,0.00')}{' '}
                    บาท
                  </p>
                </div>
              </div>
            </div>
            <span className={classes.contentDesc}>
              หมายเหตุ: หลังจากชำระเงิน คุณจะได้รับเงินคืนทาง วอลเล็ททันที
            </span>
          </div>
          <Modal styles={{ outline: 0 }} open={isLoading}>
            <Loading />
          </Modal>
        </Body>
        <Footer>
          <SubmitButton onClick={this.goToNextPage}>ชำระเงิน</SubmitButton>
        </Footer>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              ยืนยันการทำรายการ
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    userInput: _.get(state, 'motor.userInput', {}),
    balance: _.get(state, 'auth.balance', 0),
    auth: _.get(state, 'auth', {}),
    selectPrice: _.get(state, 'motor.userInput.selectPrice', 0),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
    showError: message => {
      dispatch({
        type: 'ME',
        data: {
          isShowError: true,
          errorMessage: message,
        },
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PaymentPlan))
